import React from 'react';
import { Box, Card, CardContent, Chip, Grid, Typography, Button } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CommentIcon from '@mui/icons-material/Comment';

export default function PRHeader({ title, status, repositoryLabel, author, createdLabel, filesCount = 0, commentsCount = 0, onViewPRComments }) {
  return (
    <Card sx={{ mb: 1, backgroundColor: '#0d1117', border: '1px solid #30363d', borderRadius: '10px', boxShadow: '0 8px 24px rgba(1,4,9,0.6)' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h5" sx={{ color: '#f0f6fc', fontWeight: 700 }}>{title}</Typography>
          <Chip label={(status || 'Unknown')} sx={{ backgroundColor: ((status || '').toString().toLowerCase() === 'active') ? '#122e1b' : '#21262d', color: ((status || '').toString().toLowerCase() === 'active') ? '#7ee787' : '#7d8590', border: ((status || '').toString().toLowerCase() === 'active') ? '1px solid #238636' : '1px solid #30363d', fontWeight: 700, textTransform: 'capitalize' }} />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#c9d1d9', mb: 1 }}>
              <FolderOpenIcon fontSize="small" sx={{ color: '#58a6ff' }} />
              <Typography variant="body2" sx={{ color: '#7d8590' }}>Repository</Typography>
              <Typography variant="body2" sx={{ color: '#f0f6fc', fontWeight: 600 }}>{repositoryLabel}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#c9d1d9', mb: 1 }}>
              <PersonIcon fontSize="small" sx={{ color: '#58a6ff' }} />
              <Typography variant="body2" sx={{ color: '#7d8590' }}>Author</Typography>
              <Typography variant="body2" sx={{ color: '#f0f6fc', fontWeight: 600 }}>{author || 'Unknown'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#c9d1d9', mb: 1 }}>
              <CalendarMonthIcon fontSize="small" sx={{ color: '#58a6ff' }} />
              <Typography variant="body2" sx={{ color: '#7d8590' }}>Created</Typography>
              <Typography variant="body2" sx={{ color: '#f0f6fc', fontWeight: 600 }}>{createdLabel || 'Unknown'}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#c9d1d9', mb: 1 }}>
              <InsertDriveFileIcon fontSize="small" sx={{ color: '#58a6ff' }} />
              <Typography variant="body2" sx={{ color: '#7d8590' }}>Files Changed</Typography>
              <Chip label={filesCount} size="small" sx={{ backgroundColor: '#21262d', color: '#f0f6fc', fontWeight: 600 }} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#c9d1d9' }}>
              <CommentIcon fontSize="small" sx={{ color: '#58a6ff' }} />
              <Typography variant="body2" sx={{ color: '#7d8590' }}>Comments</Typography>
              <Chip label={commentsCount} size="small" sx={{ backgroundColor: '#21262d', color: '#f0f6fc', fontWeight: 600 }} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <Button size="small" variant="outlined" onClick={onViewPRComments} sx={{ color: '#58a6ff', borderColor: '#58a6ff', '&:hover': { backgroundColor: '#58a6ff20' } }}>View PR comments</Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}


